// extracted by mini-css-extract-plugin
export default {"lineGroup":"jIcE5PGUDeWPVYrbM3Bz","dotGroup":"_3OOxG59_COU1nsd0HGL","dot":"hH8PJVKUBG9q_lTKB2dN","dotEmpty":"gd4X4ioz5BX5HYpN_P2u","label":"A63q9fOjHf3kZk4KxhlT"};